// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import UserOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
import TagsOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TagsOutlined';
import ReadOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ReadOutlined';
export default { DashboardOutlined, UserOutlined, TagsOutlined, ReadOutlined };
